var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"arrow",attrs:{"viewBox":"0 0 85.52 28"}},[_c('path',{staticStyle:{"fill":"#12100c","fill-rule":"evenodd"},attrs:{"d":"M85.52,28H0L42.35,0Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }